import emptyCRMIcon from '../../images/icons/puzzle-icon.svg';
import ctoCRMIcon from '../../images/icons/cto-icon.svg';
import bSalonCRMIcon from '../../images/icons/sparkles-icon.svg';
import { COLORS } from '../enums/colors';
import { currencies } from './items';
import { NameIdType } from '../enums/project';

export enum StructureCRMEnum {
    EMPTY = "empty",
    CAR_SERVICE = "car-service",
    BEAUTY_SALON = "beauty-salon",
}

export enum OnboardingPlanEnum {
    FREE = "Free",
    START = "Start",
    PRO = "Pro",
    BUSINESS = "Business",
}

export interface StructureCRMType {
    id: string;
    title: string;
    code: StructureCRMEnum;
    description: string;
    icon: string;
    color: string;
}

export interface OnboardingPlanType {
    title: OnboardingPlanEnum;
    description: string;
    price: string;
    currency: any;
    time: "місяць" | "рік";
    items: string[];
    label: string;
}

export const structureCRMData: StructureCRMType[] = [
    {
        id: "01",
        title: "Порожня CRM",
        code: StructureCRMEnum.EMPTY,
        description: "Почніть з чистого простору та налаштуйте CRM повністю під свій бізнес. Ви самі додаєте поля, етапи, ролі та автоматизації у зручному для вас форматі.",
        icon: emptyCRMIcon,
        color: COLORS.main1,
    },
    {
        id: "02",
        title: "Автосервіс",
        code: StructureCRMEnum.CAR_SERVICE,
        description: "Готова CRM з типовими послугами, етапами ремонту та ролями персоналу.",
        icon: ctoCRMIcon,
        color: COLORS.blue,
    },
    {
        id: "03",
        title: "Салон Краси",
        code: StructureCRMEnum.BEAUTY_SALON,
        description: "CRM з готовими послугами, записами клієнтів та ролями майстрів.",
        icon: bSalonCRMIcon,
        color: COLORS.warning
    }
];

export const onboardingPlanData: OnboardingPlanType[] = [
    {
        title: OnboardingPlanEnum.FREE,
        description: "Мікробізнес, тестування системи",
        price: "0",
        currency: currencies[1],
        time: "місяць",
        items: ["До 2 користувачів",
            "До 50 клієнтів",
            "Базові функції"],
        label: "Стартовий план"
    },
    {
        title: OnboardingPlanEnum.START,
        description: "Для невеликих команд та старту роботи",
        price: "249",
        currency: currencies[1],
        time: "місяць",
        items: ["До 3 користувачів",
            "До 1 000 клієнтів",
            "Базові функції",
            "Email-підтримка"],
        label: "Для малого бізнесу"
    },
    {
        title: OnboardingPlanEnum.PRO,
        description: "Оптимальний вибір для зростаючого бізнесу",
        price: "499",
        currency: currencies[1],
        time: "місяць",
        items: ["До 10 користувачів",
            "Автоматизації",
            "Пріоритетна підтримка",
            "Розширена аналітика",
            "Необмежені клієнти"],
        label: "Рекомендований план"
    },
    {
        title: OnboardingPlanEnum.BUSINESS,
        description: "Для команд з розширеними потребами",
        price: "999",
        currency: currencies[1],
        time: "місяць",
        items: ["Необмежені користувачі",
            "Ролі та доступи",
            "Інтеграції та API",
            "Пріоритетна підтримка"],
        label: "Максимальні можливості"
    }
]

export const paymentItemsTabs: NameIdType[] = [
    { id: "plan", name: "Тариф" },
    { id: "type", name: "Спосіб оплати" },
    { id: "history", name: "Історія платежів" },
]